import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence, useDragControls } from "framer-motion";
import { useDrag } from "@use-gesture/react";
import banner1 from '../../images/hero/banner1.png';
import banner2 from '../../images/hero/banner2.png';
import banner3 from '../../images/hero/banner1-mobile.png';
import banner4 from '../../images/hero/banner2-mobile.png';
import banner5 from '../../images/hero/banner5.jpg';
import banner6 from '../../images/hero/banner6.jpg';
import banner7 from '../../images/hero/banner7.jpg';
import banner8 from '../../images/hero/banner8.jpg';
import banner9 from '../../images/hero/banner9.jpg';
import banner10 from '../../images/hero/banner10.jpg';
import banner11 from '../../images/hero/test.png';
import { Link } from "react-router-dom";

const images = [
    { src: banner1, mobileSrc: banner3, title: "Pro Gamer Series", subtitle: "VISIONG27", link: "/page3" },
    { src: banner2, mobileSrc: banner4, title: "Pro Gamer Series", subtitle: "VISIONG27", link: "/page3" },
    { src: banner1, mobileSrc: banner3, title: "Pro Gamer Series", subtitle: "VISIONG27", link: "/page3" },
    { src: banner2, mobileSrc: banner4, title: "Pro Gamer Series", subtitle: "VISIONG27", link: "/page3" },
    { src: banner1, mobileSrc: banner3, title: "Pro Gamer Series", subtitle: "VISIONG27", link: "/page3" },
    { src: banner2, mobileSrc: banner4, title: "Pro Gamer Series", subtitle: "VISIONG27", link: "/page3" },
    { src: banner1, mobileSrc: banner3, title: "Pro Gamer Series", subtitle: "VISIONG27", link: "/page3" },
    { src: banner2, mobileSrc: banner4, title: "Pro Gamer Series", subtitle: "VISIONG27", link: "/page3" },
];

const HeroSlider: React.FC = () => {
    const [index, setIndex] = useState(0);
    const [hasLoaded, setHasLoaded] = useState(false);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const startX = useRef<number | null>(null);
    const isDragging = useRef(false);

    useEffect(() => {
        startAutoSlide();
        return () => clearInterval(intervalRef.current!);
    }, [index]);

    const startAutoSlide = () => {
        clearInterval(intervalRef.current!);
        intervalRef.current = setInterval(() => {
        nextSlide();
        }, 4000);
    };

    const nextSlide = () => {
        setHasLoaded(true);
        setIndex((prev) => (prev + 1) % images.length);
    };

    const prevSlide = () => {
        setHasLoaded(true);
        setIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    const goToSlide = (i: number) => {
        setHasLoaded(true);
        setIndex(i);
        startAutoSlide();
    };

    // --- SWIPE DETEKCIJA ---
    const handleStart = (clientX: number) => {
        startX.current = clientX;
        isDragging.current = true;
    };

    const handleMove = (clientX: number) => {
        if (!isDragging.current || startX.current === null) return;
        const delta = clientX - startX.current;
        if (Math.abs(delta) > 50) {
        if (delta > 0) prevSlide();
        else nextSlide();
        isDragging.current = false; // Resetujemo
        }
    };

    const handleEnd = () => {
        isDragging.current = false;
    };

    useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => handleMove(e.clientX);
        const handleMouseUp = () => handleEnd();

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);

        return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        };
    }, []);

    return (
        <div 
            className="container mx-auto relative h-full w-[calc(100%-30px)] h-[fit-content] overflow-hidden rounded-lg cursor-pointer"
            onMouseDown={(e) => handleStart(e.clientX)}
            onTouchStart={(e) => handleStart(e.touches[0].clientX)}
            onTouchMove={(e) => handleMove(e.touches[0].clientX)}
            onTouchEnd={handleEnd}
        >
            <div
                key={index}
                className="h-full flex items-center justify-center w-full flex mx-auto"
            >
                <Link to='shop' draggable="false">
                <picture>
                    <source
                        media="(max-width: 640px)" // Tailwind 'sm' breakpoint
                        srcSet={images[index].mobileSrc}
                    />
                    <img
                        className="rounded-xl w-screen"
                        src={images[index].src}
                        alt={`Slide ${index}`}
                        style={{ width: '100%', height: 'auto' }}
                        draggable="false"
                    />
                </picture>
                </Link>
                {/* Overlay tekst
                <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center pl-10 text-white">
                    <h2 className="text-xl font-semibold">{images[index].title}</h2>
                    <h1 className="text-3xl font-bold my-2 bg-yellow-400 text-black inline-block px-3 py-1 rounded">
                        {images[index].subtitle}
                    </h1>
                    <button 
                        className="mt-4 bg-orange-500 px-4 py-2 rounded text-white font-semibold hover:bg-orange-600"
                        onClick={() => (window.location.href = images[index].link)}
                    >
                        More Details
                    </button>
                </div> */}
            </div>

            {/* Indikatori */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
                {images.map((_, i) => (
                    <button
                        key={i}
                        onClick={() => goToSlide(i)}
                        className={`w-2 h-2 rounded-full transition ${
                            index === i ? "bg-white scale-125" : "bg-gray-500"
                        }`}
                    />
                ))}
            </div>
        </div>
    );
};

export default HeroSlider;
